import { BadImplementationException, Module, } from '@nu-art/ts-common';
export class BaseHttpModule_Class extends Module {
    origin;
    timeout = 10000;
    defaultHeaders = {};
    defaultOnComplete;
    defaultOnError;
    constructor() {
        super();
        this.setDefaultConfig({ compress: true });
    }
    init() {
        this.timeout = this.config.timeout || this.timeout;
    }
    getOrigin() {
        return this.origin;
    }
    shouldCompress() {
        return this.config.compress;
    }
    setDefaultOnComplete = (defaultOnComplete) => {
        this.defaultOnComplete = defaultOnComplete;
    };
    setDefaultOnError = (defaultOnError) => {
        this.defaultOnError = defaultOnError;
    };
    addDefaultHeader(key, header) {
        this.defaultHeaders[key] = header;
    }
    getDefaultHeaders() {
        return Object.keys(this.defaultHeaders).reduce((toRet, _key) => {
            const defaultHeader = this.defaultHeaders[_key];
            switch (typeof defaultHeader) {
                case 'string':
                    toRet[_key] = [defaultHeader];
                    break;
                case 'function':
                    toRet[_key] = defaultHeader();
                    break;
                case 'object':
                    if (Array.isArray(defaultHeader)) {
                        toRet[_key] = defaultHeader;
                        break;
                    }
                // eslint-disable-next-line no-fallthrough
                case 'boolean':
                case 'number':
                case 'symbol':
                case 'bigint':
                case 'undefined':
                    throw new BadImplementationException(`Headers values can only be of type: (() => string | string[]) | string | string[], got type ${typeof defaultHeader} `);
            }
            return toRet;
        }, {});
    }
}
//# sourceMappingURL=BaseHttpModule.js.map